import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateInventory(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldCreateInventoryAttempt', handleCreateInventory, api);
}

function* handleCreateInventory(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        branchCode,
        products,
        metalType,
    } = reduxState.gold.params.createInventoryParams;

    const response = yield* call([api, api.createInventory], {
        authToken,
        branchCode,
        products,
        metalType,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldCreateInventoryFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        toast.success(SuccessMessages.GoldCreateInventorySuccess);
        yield put(combinedActions.goldSetIsCreateInventoryModalOpen(false));
        yield put(combinedActions.goldCreateInventorySuccess());
        yield put(combinedActions.goldGetInventoryListingAttempt());
    }
}
